import { type StreamFollowUp } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT } from './CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT';

/**
 * Creates a standalone synthetic follow-up containing only the
 * "Create a Confluence page from this response" suggestion.
 * Used when the backend did not send any follow-up message.
 */
export function createSyntheticCreatePageFollowUp(): StreamFollowUp {
	return {
		type: 'FOLLOW_UP_QUERIES',
		message: {
			follow_ups: [
				{
					type: 'SYNTHETIC',
					text: CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT,
				},
			],
		},
		millisOffset: 0,
	};
}
